import { render } from "./DefaultFooter.vue?vue&type=template&id=1f747d64&scoped=true&ts=true"
import script from "./DefaultFooter.vue?vue&type=script&lang=ts"
export * from "./DefaultFooter.vue?vue&type=script&lang=ts"

import "./DefaultFooter.vue?vue&type=style&index=0&id=1f747d64&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f747d64"]])

export default __exports__